import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {OverlayService} from "../../overlay/overlay.service";
import {LargeMessageService} from "../../services/large-message.service";
import {LargeMessageInput} from "../../interfaces/large-message-input";
import {Overlayable} from "../../interfaces/overlayable";
import {ButtonColor} from "../../atoms/button/button-color";
import {LargeMessageTheme} from "../../enums/large-message-theme";
import {DotLottie} from "@lottiefiles/dotlottie-web";
import gsap from "gsap";
@Component({
  selector: 'brt-large-message',
  templateUrl: './large-message.component.html',
  styleUrls: ['./large-message.component.scss']
})
export class LargeMessageComponent implements OnInit, AfterViewInit, OnDestroy, Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  @Input("data") set setData(data: LargeMessageInput) {
    if(data.theme === LargeMessageTheme.BLUE) {
      this.buttonColor = "white";
      this.animlineColor = "white";
    } else if(data.theme === LargeMessageTheme.GOLD) {
      this.animLoop = false;
      this.animAutoplay = false;
    } else if(data.theme === LargeMessageTheme.GREEN) {
      this.buttonColor = 'white';
      this.animlineColor = 'white';
    }

    this.data = data;
  }

  @ViewChild('badgeImgElement') badgeImgElement!: ElementRef<HTMLImageElement>;

  data?: LargeMessageInput;
  buttonColor: ButtonColor = "black";
  animlineColor = "black";

  animateBadge = false; // it should have other logic but since we have only 1 case leave it so
  animateBadgeInterval = -1;

  ready = false;

  animAutoplay = true;
  animLoop = true;

  animInterval = -1;

  isContinuing = false;
  private isDestroyed = false;

  gsapBadgeAnimation?: gsap.core.Tween;

  constructor(private overlay: OverlayService, private largeMessageService: LargeMessageService) {
  }

  ngOnInit() {


  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.ready = true;

      if(this.data?.badgeSrc) {
        if(this.badgeImgElement) {
          this.gsapBadgeAnimation = gsap.to(this.badgeImgElement.nativeElement, {
            keyframes: {
              "0%": { scale: 0, rotate:" 0deg" },
              "30%": { scale: 1.2, rotate: "0deg" },
              "40%": { rotate: "-20deg", scale: 1.2 },
              "50%": { rotate: "20deg", scale: 1.2 },
              "60%": { rotate: "-20deg", scale: 1.2 },
              "70%": { rotate: "0deg", scale: 1.2 },
              "100%": { scale: 1, rotate: "0deg" }
            },
            ease: "power0.out",
            duration: 1.2,
            onComplete: () => {
              setTimeout(() => {
                if(this.gsapBadgeAnimation) {
                  this.gsapBadgeAnimation.play(0.3);
                }
              }, 5000);
            }
          });


        }
      }
    }, 100);
  }

  async continue() {
    if(this.isContinuing) return;

    const result = this.data?.primaryButtonCallback?.();
    // Async callback (e.g. opening the next overlay after loading): stay open until it is done,
    // so there is no empty gap between this message and the next overlay
    if(result instanceof Promise) {
      this.isContinuing = true;
      try {
        await result;
      } finally {
        this.isContinuing = false;
      }
      // Already closed in the meantime (X / backdrop)
      if(this.isDestroyed) return;
    }
    this.onClosed.emit(true);

  }

  onSecondaryButtonClick(): void {
    if(this.data?.secondaryButtonCallback) {
      this.data?.secondaryButtonCallback();
    }
    // this.onClosed.emit(true);
  }

  cancel() {
    if(this.data?.closeCallback) {
      this.data.closeCallback();
    }
    this.onClosed.emit(true);
  }

  onAnimCreated($event: DotLottie) {
    if(!this.animAutoplay) {
      this.animInterval = window.setInterval(() => {
        if(!$event.isPlaying) {
          $event.stop();
          $event.play();
        }
      }, 6000);
    }
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    window.clearInterval(this.animInterval);
    window.clearInterval(this.animateBadgeInterval);

    if(this.gsapBadgeAnimation) {
      this.gsapBadgeAnimation.kill();
      this.gsapBadgeAnimation = undefined;
    }
  }
}
